import React from "react";

export default function ({ title, classes, beforeTitle }) {
  return <button type="submit" className={`btn btn-lg btn-primary mb-5${classes ? " " + classes : ''}`}>
    <span className="indicator-label">{beforeTitle}{title}</span>
  </button>
}